import { FilteredUserInfo } from "./filtered-user-info";
import { UserInfo } from "./user-info";
import { UserInfoClient } from "./user-info-client";
import { UserInfoFacility } from "./user-info-facility";
import { UserInfoRole } from "./user-info-role";

export class AdminUserState {
  allUsers!: UserInfo[];
  filteredUsers!: FilteredUserInfo[];
  clientsFilter!: UserInfoClient[];
  rolesFilter!: UserInfoRole[];
  facilitiesFilter!: UserInfoFacility[];
}
